<script setup>
import OfModal from "@dk.onlinefundraising/vue-utils/src/utils/OfModal.vue";
import { ref, defineEmits, defineProps } from "vue";
import OfUserForm from "./OfUserForm.vue"
import OfButton from "@dk.onlinefundraising/vue-utils/src/utils/OfButton.vue";
import requests from "@/OfOnboardingRequests";
import { userAllowed } from "@/functions";
import { user as currentUser } from "@/store";

const props = defineProps({
    user: Object,
})

const user = ref(props.user)

const emit = defineEmits(['close', 'getUsers'])

function requestReset() {
    requests.requestPasswordReset(user.value.userGuid);
}
function updateUser() {
    requests.updateUser(user.value);
}
function archiveUser() {
    if (confirm('Are you sure')) {
        requests.archiveUser(user.value.userGuid).then(() => {
            emit('close');
            emit('getUsers');
        });
    }
}
</script>
<template>
    <OfModal @close="emit('close')">

        <template #heading>
            Edit user
        </template>

        <template #top>

        </template>

        <template #buttons>
            <OfButton v-if="userAllowed('UPDATE_USER')" coloring="cancel" text="Archive" @click="archiveUser()" />
            <OfButton v-if="userAllowed('UPDATE_USER') || user.userGuid == currentUser.guid" coloring="primary" text="Update" @click="updateUser()" />
        </template>

        <template #middle>

            <OfUserForm :user="user" />

            <a @click.prevent="requestReset()">Request password reset</a>
        </template>

    </OfModal>
</template>